import { styled } from '@uhg-abyss/web/tools/styled';
import { Link } from '@uhg-abyss/web/ui/Link';

export const ExploreUnaitedHealthPremiumLink = styled(Link, {
  fontSize: '14px !important',
  fontWeight: '600 !important',
  lineHeight: '18px !important',
  letterSpacing: '0 !important',
  color: '$core.color.brand.60 !important',
  verticalAlign: 'middle !important',
  '&::before': {
    borderBottom: 'none !important',
  },
});
